<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo d-block">
          <div
            style="width: 300px"
            class="d-flex align-items-center justify-content-center mb-1 m-auto"
          >
            <img style="width: 100%" src="/sofIAweb.webp" alt="SofIA" />
          </div>
          <p style="color: #5e5873" class="brand-text ml-1 text-center mt-2">
            {{ $t("change_password") }}
          </p>
        </b-link>
        <validation-observer ref="updateForm" #default="{ invalid }">
          <b-form class="auth-login-form mt-2" @submit.prevent="updatePassword">
            <b-form-group label-for="new_password" :label="$t('new_password')">
              <validation-provider
                #default="{ errors }"
                :name="$t('new_password')"
                rules="required"
              >
                <b-form-input
                  type="password"
                  id="new_password"
                  v-model="newPassword"
                  name="new_password"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('new_password')"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label-for="new_password_confirm"
              :label="$t('new_password_confirm')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('new_password_confirm')"
                rules="required"
              >
                <b-form-input
                  type="password"
                  id="new_password_confirm"
                  v-model="confirmPassword"
                  name="new_password_confirm"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('new_password_confirm')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <p v-if="passwordMismatch" style="color: red">
              Las contraseñas no coinciden
            </p>
            <div
              class="mt-2"
              style="display: flex; justify-content: end; align-items: center"
            >
              <b-button @click="back()">
                {{ $t("cancel") }}
              </b-button>
              <b-button
                class="ml-1"
                variant="primary"
                type="submit"
                :disabled="passwordMismatch"
              >
                {{ $t("pages.orders.form.label.update") }}
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import { UsersUpdatePassword } from "@core/api/request";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BInputGroup,
  BInputGroupAppend,
  BCol,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { loginCustomer } from "@core/api/request";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import { setCookie } from "@/auth/CookiesManager";
import { showLoading, stopLoading } from "@core/utils/utils";
export default {
  components: {
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    VuexyLogo,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BCol,
  },
  data() {
    return {
      guid: "",
      newPassword: "",
      confirmPassword: "",
    };
  },
  mounted() {
    this.guid = this.$route.params;
  },
  computed: {
    passwordMismatch() {
      return this.newPassword !== this.confirmPassword;
    },
  },
  methods: {
    updatePassword() {
      this.$refs.updateForm.validate().then((success) => {
        if (success) {
          showLoading();
          const body = {
            guidUser: this.guid.guid,
            newPassword: this.newPassword,
          };
          UsersUpdatePassword(body)
            .then((resp) => {
              stopLoading();
              if (resp.data.err) {
                stopLoading();
                this.$refs.generateForm.setErrors(resp.data.message);
                this.alertToast("danger", "Alerta error", resp.data.message);
              } else {
                console.log("Respuesta XX", resp);
                this.back();
              }
            })
            .catch((error) => {
              console.log("error", error);
              stopLoading();
              this.$refs.generateForm.setErrors(resp.data.message);
              this.alertToast("danger", "Alerta error", resp.data.messager);
            });
        }
      });
    },

    back() {
      this.$router.push({
        name: "auth-login",
      });
      this.userEmail = "";
    },
  },
};
</script>

<style lang="scss" scoped></style>
